import {getOwnerDocument} from './utils';

function isStyleVisible(element: Element) {
  const windowObject = getOwnerDocument(element)?.defaultView || window;
  if (
    !(element instanceof windowObject.HTMLElement) &&
    !(element instanceof windowObject.SVGElement)
  ) {
    return false;
  }

  const {display, visibility} = element.style;

  let isVisible =
    display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';

  if (isVisible) {
    // @ts-expect-error - Property 'getComputedStyle' does not exist on type '(Window & typeof globalThis) | null'
    const {getComputedStyle} = element.ownerDocument.defaultView;
    const {display: computedDisplay, visibility: computedVisibility} =
      getComputedStyle(element);

    isVisible =
      computedDisplay !== 'none' &&
      computedVisibility !== 'hidden' &&
      computedVisibility !== 'collapse';
  }

  return isVisible;
}

function isAttributeVisible(element: Element, childElement?: Element) {
  return (
    !element.hasAttribute('hidden') &&
    (element.nodeName === 'DETAILS' &&
    childElement &&
    childElement.nodeName !== 'SUMMARY'
      ? element.hasAttribute('open')
      : true)
  );
}

/**
 * Adapted from https://github.com/testing-library/jest-dom and
 * https://github.com/vuejs/vue-test-utils-next/.
 * Licensed under the MIT License.
 * @param element - Element to evaluate for display or visibility.
 */
export function isElementVisible(
  element: Element,
  childElement?: Element,
): boolean {
  return (
    element.nodeName !== '#comment' &&
    isStyleVisible(element) &&
    isAttributeVisible(element, childElement) &&
    (!element.parentElement || isElementVisible(element.parentElement, element))
  );
}
